import React, { useEffect, useContext, useState } from 'react';
import {
  Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalCloseButton, useToast,
} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import AssignSelector, { getAssignEmployee } from './AssignSelector';
import type { Employee } from '../../contexts/types';
import { WebAPIContext } from '../../contexts/WebAPIContext';

/**
 * 担当者設定モーダル
 * @param isOpen オープンフラグ
 * @param onClose ×ボタン押下処理
 * @param onOk OKボタン押下処理
 * @param title タイトル
 * @param prevSelectedEmployeeIds 前回選択担当者の従業員IDリスト
 * @param employees 担当者一覧情報（従業員情報）
 */
const AssignModal: React.FC<any> = ({ isOpen, onClose, onOk, title, prevSelectedEmployeeIds, disabledEmployeeIds, employees, maxAssignees }) => {

  /** 翻訳 */
  const { t } = useTranslation();
  /** トースト表示用 */
  const toast = useToast();

  /** 通信オブジェクト */
  const WebAPI = useContext(WebAPIContext);

  /** 前回選択担当者の従業員IDリスト */
  const selectedEmployeeIds = prevSelectedEmployeeIds ?? [];

  /** 従業員マスタ情報 */
  const [employeeList, setEmployeeList] = useState<Employee[]>([]);

  /**
   * 従業員マスタ情報変更時
   */
  useEffect(() => {
    if (!employees) {
      // 未設定の場合は従業員マスタ情報を取得する。
      fetchData();
    } else {
      // 引数で受け取った従業員マスタ情報を参照する。
      setEmployeeList(employees);
    }
  }, [employees]);

  /**
   * 従業員マスタ情報を取得する。
   */
  const fetchData = async () => {
    // 従業員情報取得
    const result = await getAssignEmployee(WebAPI.request);

    if (result) {
      setEmployeeList(result);
    } else {
      toast({
        title: t('common.message.initialDisplayError'),
        description: t('common.message.fetchEmployeesFailed'),
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    }
  }

  /**
   * 本ポップアップを閉じ、結果を呼び出し元に返す。
   */
  const handleOk = (result: Employee[]) => {
    onClose();

    onOk(result);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false} isCentered scrollBehavior="inside" size="2xl">
      <ModalOverlay />
      <ModalContent maxHeight="90vh">
        <ModalHeader>{title}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <AssignSelector employees={employeeList} prevSelectedEmployeeIds={selectedEmployeeIds} disabledEmployeeIds={disabledEmployeeIds} onOk={handleOk} error={null} maxAssignees={maxAssignees} />
        </ModalBody>
      </ModalContent>
    </Modal >
  );
};

export default AssignModal;